import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'messages'
const verb = 'delete'

export default class OspreyDeleteDraft extends BaseAction {
    constructor(dataKey) {
        const id = '0b214662-6717-47af-a8cf-062ac190d504'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    deleteDraft(params) {
        const { messageId, ownerOrn } = params
        this.path = `/${resource}/${messageId}?X-Context-Orn=${ownerOrn}`

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/messages/messages-delete.js